import en from 'vuetify/es5/locale/en';
import vi from 'vuetify/es5/locale/vi';

const VUETIFY_EN_OVERRIDE = {
};

const VUETIFY_VI_OVERRIDE = {
  dataTable: {
    itemsPerPageText: "Số dòng mỗi trang"
  }
};

const locales = { en: { ...en, ...VUETIFY_EN_OVERRIDE }, vi: { ...vi, ...VUETIFY_VI_OVERRIDE } };

export default locales;
